import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Servicios } from "../components/site/Servicios";
import { SobreDoctor } from "../components/site/SobreDoctor";
import { AreasAtencion } from "../components/site/AreasAtencion";
import { Testimonios } from "../components/site/Testimonios";
import { Ubicacion } from "../components/site/Ubicacion";
import { FAQ } from "../components/site/FAQ";
import { Footer } from "../components/site/Footer";
import { FloatingCTA } from "../components/site/FloatingCTA";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-[hsl(var(--cream))]">
      <Navbar />
      <Hero />
      <Servicios />
      <SobreDoctor />
      <AreasAtencion />
      <Testimonios />
      <Ubicacion />
      <FAQ />
      <Footer />
      <FloatingCTA />
    </main>
  );
}
